import React from 'react';
import { observer } from 'mobx-react';
import {
    IconButton,
    Tooltip,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Divider
} from '@mui/material';
import { Settings, ViewModule, ViewList } from '@mui/icons-material';
import { lightBlue } from '@mui/material/colors';

import RouterStore from '@/store/RouterStore';
import ControleGabineteStore from '@/store/ControleGabineteStore';
import LayoutStore from '@/store/LayoutStore';

const MenuControleGabinete: React.FC = observer(() => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const isDark = LayoutStore.isTemaDark;

    const abrirMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const fecharMenu = () => {
        setAnchorEl(null);
    };

    const abrirConfiguracaoGabinete = () => {
        fecharMenu();
        RouterStore.push('/configuracaoGabinete');
    };

    const alterarVisualizacao = (modo: 'BLOCO' | 'LISTA') => {
        fecharMenu();
        ControleGabineteStore.setModoVisualizacao(modo);
    };

    if (!RouterStore.isControleGabinete) {
        return null;
    }

    return (
        <>
            <Tooltip title="Opções do gabinete">
                <IconButton
                    color="inherit"
                    onClick={abrirMenu}
                    id="configurarGabinete"
                >
                    <Settings />
                </IconButton>
            </Tooltip>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={fecharMenu}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: isDark
                            ? {
                                  backgroundColor: '#2e2e2e',
                                  color: '#e8e8e8',
                                  border: '1px solid rgba(255, 255, 255, 0.14)',
                                  '& .MuiListItemIcon-root': {
                                      color: '#b8b8b8',
                                  },
                                  '& .MuiListItemText-primary': {
                                      color: '#e8e8e8',
                                  },
                                  '& .MuiDivider-root': {
                                      borderColor: 'rgba(255, 255, 255, 0.14)',
                                  },
                                  // Item do modo atualmente selecionado (fica desabilitado):
                                  // mantém legível em vez de quase transparente.
                                  '& .MuiMenuItem-root.Mui-disabled': {
                                      opacity: 1,
                                  },
                                  '& .MuiMenuItem-root.Mui-disabled .MuiListItemText-primary': {
                                      color: lightBlue[300],
                                      fontWeight: 600,
                                  },
                                  '& .MuiMenuItem-root.Mui-disabled .MuiListItemIcon-root': {
                                      color: lightBlue[300],
                                  },
                                  '& .MuiMenuItem-root.Mui-selected': {
                                      backgroundColor: 'rgba(25, 118, 210, 0.22)',
                                  },
                                  '& .MuiMenuItem-root:hover': {
                                      backgroundColor: 'rgba(255, 255, 255, 0.08)',
                                  },
                              }
                            : undefined,
                    },
                }}
            >
                <MenuItem onClick={abrirConfiguracaoGabinete}>
                    <ListItemIcon>
                        <Settings fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Configurar gabinete" />
                </MenuItem>

                <Divider />

                <MenuItem
                    selected={ControleGabineteStore.isVisualizacaoEmBloco}
                    disabled={ControleGabineteStore.isVisualizacaoEmBloco}
                    onClick={() => alterarVisualizacao('BLOCO')}
                >
                    <ListItemIcon>
                        <ViewModule
                            fontSize="small"
                            color={
                                ControleGabineteStore.isVisualizacaoEmBloco
                                    ? 'primary'
                                    : 'inherit'
                            }
                        />
                    </ListItemIcon>
                    <ListItemText primary="Visualizar em blocos" />
                </MenuItem>

                <MenuItem
                    selected={ControleGabineteStore.isVisualizacaoEmLista}
                    disabled={ControleGabineteStore.isVisualizacaoEmLista}
                    onClick={() => alterarVisualizacao('LISTA')}
                >
                    <ListItemIcon>
                        <ViewList
                            fontSize="small"
                            color={
                                ControleGabineteStore.isVisualizacaoEmLista
                                    ? 'primary'
                                    : 'inherit'
                            }
                        />
                    </ListItemIcon>
                    <ListItemText primary="Visualizar em lista" />
                </MenuItem>
            </Menu>
        </>
    );
});

export default MenuControleGabinete;
